import { object, string } from 'yup'
import { ShipperApplication } from 'apps/marketplace/apiTypes/requestForProposals'

export interface EditRfpSchema {
  salesforceRfpId?: string
  shipperApplication?: ShipperApplication
  requestForProposalType?: string
}

export interface IEditRfpSchema {
  salesforceRfpId?: string
  shipperApplicationId?: number
  requestForProposalType?: string
}

export const EditRfpSchema = object<EditRfpSchema>({
  shipperApplication: object<ShipperApplication>(),
  salesforceRfpId: string().notRequired(),
  requestForProposalType: string().notRequired(),
})
